const jsonHeaders = { 'Content-Type': 'application/json' };

const handleResponse = async (res) => {
  const text = await res.text();
  let data = null;

  // Try to parse JSON, but do NOT crash if it isn't valid JSON
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  // If the HTTP status is not OK, surface a clean error
  if (!res.ok) {
    const message =
      (data && (data.error || data.message)) ||
      text ||                           // raw body as a last resort
      `Request failed (${res.status})`;

    throw new Error(message);
  }

  return data;
};

export async function apiListCoaches() {
  const res = await fetch('/api/coaches');
  return handleResponse(res);
}

export async function apiGetCoach(id) {
  const res = await fetch(`/api/coaches/${id}`);
  return handleResponse(res);
}

export async function apiCreateCoach(payload) {
  const res = await fetch('/api/coaches', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function apiUpdateCoach(id, payload) {
  const res = await fetch(`/api/coaches/${id}`, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify(payload),
  });
  return handleResponse(res);
}

export async function apiDeleteCoach(id) {
  const res = await fetch(`/api/coaches/${id}`, {
    method: 'DELETE',
  });
  return handleResponse(res);
}